import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';


@Component({
    selector: 'app-pain-score-cat-item-v2',
    templateUrl: './pain-score-cat-item-v2.component.html',
    styleUrl: './pain-score-cat-item-v2.component.scss',
    imports: [ItemContentComponent,],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainScoreCatItemComponentV2 implements SheetItemComponentBase {

	@Input() row!: Row;
    @Input() startLabel!: string;
    @Input() endLabel!: string;
	
	constructor() {
	}
}
